const LANGS = ['en', 'pl', 'de']

exports.LANGUAGE_KEYS = LANGS

exports.APP_PREFIXES = LANGS.map(lang => `/${lang}/app/*`)
